import { createSlice } from '@reduxjs/toolkit';
import { incidentsApi } from '../functions/IncidentsApi';
import { toast } from 'react-toastify';

export const NERIS_GROUP_TYPE_LIST = [
  'fire',
  'medical',
  'hazsit',
  'pubserv',
  'rescue',
  'noemerg',
  'lawenforce',
];

const initialState = {
  formSettings: {},
  loadingFormSettings: false,

  type: {
    groups: [],
    types: [],
  },
  loadingTypeSettings: false,
  typeSaveFetching: false,
};

export const nerisSettingsReducer = createSlice({
  name: 'nerisSettingsReducer',
  initialState,
  reducers: {
    setFormSettings: (state, action) => {
      state.formSettings = action.payload;
    },
    setLoadingFormSettings: (state, action) => {
      state.loadingFormSettings = action.payload;
    },

    setTypeSettings: (state, action) => {
      state.type = action.payload || initialState.type;
    },
    setLoadingTypeSettings: (state, action) => {
      state.loadingTypeSettings = action.payload;
    },
    setTypeSaveFetching: (state, action) => {
      state.typeSaveFetching = action.payload;
    },
  },
});

export const {
  setFormSettings,
  setLoadingFormSettings,
  setTypeSettings,
  setLoadingTypeSettings,
  setTypeSaveFetching,
} = nerisSettingsReducer.actions;

export default nerisSettingsReducer.reducer;

let currentFormSettingsController = null;
export const getReportFormSettings = (groupType) => async (dispatch) => {
  try {
    if (currentFormSettingsController) {
      currentFormSettingsController.abort();
    }
    currentFormSettingsController = new AbortController();

    dispatch(setLoadingFormSettings(true));
    const response = await incidentsApi.getFormSettings({
      params: {
        type: groupType,
      },
      signal: currentFormSettingsController.signal,
    });

    if (response.status === 200) {
      dispatch(setFormSettings(response.data));
    } else throw new Error(response);
  } catch (err) {
    if (err.name !== 'AbortError') {
      console.log(err);
    }
    console.log(err);
  } finally {
    dispatch(setLoadingFormSettings(false));
    currentFormSettingsController = null;
  }
};

export const saveFormSettings = (data) => async (dispatch) => {
  try {
    const response = await incidentsApi.saveFormSettings(data);
    if (response.status === 200) {
    } else throw new Error(response);
  } catch (err) {
    toast.error('Failed to saving settings');
    console.log(err);
  }
};

export const getTypeFormSettings = () => async (dispatch) => {
  try {
    dispatch(setLoadingTypeSettings(true));
    const response = await incidentsApi.getTypeFormSettings();

    if (response.status === 200) {
      dispatch(setTypeSettings(response.data));
    } else throw new Error(response);
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(setLoadingTypeSettings(false));
  }
};

export const saveTypeFormSettings = (data) => async (dispatch) => {
  try {
    dispatch(setTypeSaveFetching(true));
    const response = await incidentsApi.saveTypeFormSettings(data);
    if (response.status === 200) {
      dispatch(setTypeSettings(data));
    } else throw new Error(response);
  } catch (err) {
    toast.error(err.message);
    console.log(err);
  } finally {
    dispatch(setTypeSaveFetching(false));
  }
};
